import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class CandidateAIReasoning {
  description: string = ""
  score: number = 0

  constructor(
    data: {
      description: string
      score: number
    } | null = null,
  ) {
    if (data) {
      this.description = data.description
      this.score = data.score
    }
  }
}
